var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('ckeditor',{attrs:{"config":_vm.config,"editor":_vm.editor},on:{"input":_vm.onInput,"ready":_vm.onEditorReady},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }